import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Stack,
  Text,
} from "@chakra-ui/react";
import { POSTS_TYPE_VALUE_PAGE } from "@raiden/library/constants/posts";
import { useConfiguration } from "@raiden/library/hooks/useConfiguration";
import useTranslate from "@raiden/library/hooks/useTranslate";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { motion } from "framer-motion";
import { memo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Href } from "../../components/Href";
import { Icon } from "../../components/Icon";

/**
 * @param {{
 * accept: () => void,
 * refuse: () => void,
 * close: () => void,
 * }} param0
 * @returns
 */
function CookiesModal({ accept, refuse, close }) {
  const intl = useIntl();

  const translate = useTranslate();

  const { configuration } = useConfiguration();

  const postLegalNotice = configuration.posts?.[POSTS_TYPE_VALUE_PAGE]?.find(
    (post) => post.alias === process.env.NEXT_PUBLIC_POST_ALIAS_LEGAL_NOTICE,
  );

  return (
    <motion.div
      style={{ position: "fixed", right: 0, bottom: 0 }}
      initial={{
        transform: "translateY(25%)",
        opacity: 0,
      }}
      animate={{
        transform: "translateY(0%)",
        opacity: 1,
      }}
      exit={{
        transform: "translateY(25%)",
        opacity: 0,
      }}>
      <Box
        role="dialog"
        aria-labelledby="modal-cookies-title"
        aria-describedby="modal-cookies-description"
        m="1rem"
        bg="#fff"
        maxW="835px"
        borderRadius="0.25rem"
        p="0.75rem"
        boxShadow="0px 2px 4px rgba(57, 58, 151, 0.25)">
        <Stack spacing="0.5rem">
          <HStack spacing="1rem" justify="space-between" color="#002538">
            <Text
              id="modal-cookies-title"
              flexGrow={1}
              variant="h4"
              color="brandPrimary.900">
              <FormattedMessage defaultMessage="Ce site utilise des cookies" />
            </Text>

            <IconButton
              onClick={close}
              icon={<Icon icon="ms_close" size="24px" />}
              variant="ghost"
              aria-label={intl.formatMessage({ defaultMessage: "Fermer" })}
            />
          </HStack>

          <Text id="modal-cookies-description" variant="text-14">
            <FormattedMessage defaultMessage="Les cookies nous permettent de personnaliser notre contenu pour l'adapter à vos besoins et d'analyser notre trafic. Vos données ne seront jamais partagées avec des partenaires à des fins publicitaires.  Vous pouvez à tout moment nous contacter par mail pour révoquer votre consentement." />
          </Text>

          <Flex flexWrap="wrap" gap="0.75rem" justify="flex-end" align="center">
            {postLegalNotice && (
              <Href
                href={generateFrontPath({
                  id: "@front.page",
                  parameters: {
                    postSlug: `${postLegalNotice.id}-${translate(
                      postLegalNotice.slug,
                    )}`,
                  },
                })}>
                <Button
                  variant="link"
                  rightIcon={
                    <Icon
                      icon="ms_chevron_right"
                      color="gray.400"
                      size="24px"
                    />
                  }>
                  <Text color="brandPrimary.700">
                    <FormattedMessage defaultMessage="Voir les mentions légales" />
                  </Text>
                </Button>
              </Href>
            )}

            <Button onClick={refuse} variant="outline">
              <Text as="span">
                <FormattedMessage defaultMessage="Je refuse l'utilisation des cookies" />
              </Text>
            </Button>

            <Button onClick={accept} colorScheme="brandPrimary">
              <FormattedMessage defaultMessage="J'autorise tous les cookies" />
            </Button>
          </Flex>
        </Stack>
      </Box>
    </motion.div>
  );
}

export default memo(CookiesModal);
